import { render, staticRenderFns } from "./balance_account.vue?vue&type=template&id=8e795f04&scoped=true&"
import script from "./balance_account.vue?vue&type=script&lang=js&"
export * from "./balance_account.vue?vue&type=script&lang=js&"
import style0 from "./balance_account.vue?vue&type=style&index=0&id=8e795f04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e795f04",
  null
  
)

export default component.exports